export default __webpack_public_path__ + "static/NeueMontreal-Bold-be9389e743403d6264fad6f11f2853bb.woff";